import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { Observable } from 'rxjs';
import { _get } from '../../../base.service';

@Injectable({
  providedIn: 'root',
})
export class GetStandardPriceForImmoSoldRentedControllerRequestService {
  private static BASE_URL = '/immo/getStandardPriceForSoldRented';
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;

  private readonly deserialize = (res) => res as number;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get(
      GetStandardPriceForImmoSoldRentedControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public getStandardPriceForSoldRented(subProjectId: number): Promise<number> {
    return this.get(`/${subProjectId}`, this.deserialize).toPromise();
  }
}
